/*=======================================================================
 * $Id: application.js 95083 2016-12-15 10:48:33Z michael.biebl $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define([
  "backbone",
  "moment",
  "underscore",
  "extensions",
  "client/application",
  "component!stack",
  "service/stub",
  "api/v2/personalization",
  "service/channel",
  "service/channels",
  "utils/browser",
  "model/persisted_collection",
  "api/v2/resources",
  "jquery"
], function (
  Backbone,
  moment,
  _,
  Extensions,
  Application,
  Stack,
  Stub,
  Personalization,
  Channel,
  Channels,
  Browser,
  PersistedCollection,
  Resources,
  $
) {

  var QueryProfiler = function (options) {
    this.application = options.application;
    this.listenTo(this.application, "destroy", this.destroy);
    options = options || {};
    var profilerSettings = options.profilerSettings || {};
    this.SEARCH_INTERVALL = profilerSettings.searchIntervalSeconds || 60;

    this.WEIGHT_PREVIEW = profilerSettings.actionWeightPreview || 0.5;
    this.WEIGHT_OPENHREF = profilerSettings.actionWeightOpenHREF || 1;
    this.WEIGHT_CUSTOM_ACTIONS = 1;
    this.TRIGGER_ACTION_NAMES = [
      "customAction",
      "collectResult",
      "saveSearch",
      "exportSearch"
    ];
    this.AUTOMATIC_TRIGGER_ACTION_TYPES = [
      'queryURLParameter',
      'autoStartSearch'
    ];
    this.QUERY_TRIGGER_TYPES = {
      USER_QUERY: 'USER_QUERY',
      REFINEMENT: 'REFINEMENT',
      AUTOMATIC: 'AUTOMATIC'
    };

    if (options.parentProfiler) {
      this.parentProfiler = options.parentProfiler;
      this.queryContext = options.parentProfiler.queryContext;
    } else {
      this.queryContext = {query_id: this.getTime() };
      this.sessionContext = this.setNewSession();
    }

    this.personalizationIsEnabled = options.enablePersonalization;
    this.personalizationQueryContextProperties = options.personalizationQueryContextProperties;

    this.initialQueryTriggerActionURLParameterHandled = false;

    this.currentQueryObject = null;
    this.currentRefinements = null;
    this.listenTo(this.application, "beforeactionperformed", this.beforeactionPerformed);
    this.listenTo(this.application, "actionperformed", this.actionPerformed);
    this.listenTo(this.application, "changeUserQueryTab", this.afterChangeView);

    this.scrollTimer_preview = null;
    this.scrollTimer_window = null;

    this.userHasScrolled = false;
    //$(window).on("scroll", _.bind(this.handleWindowScrolling, this));
  }

  _.extend(QueryProfiler.prototype, Backbone.Events, {

    registerSearchModel: function (model) {
      this.listenTo(model, "changeinput", this.onUserQuery);
      this.listenTo(this.application.models.stack, "closeStack", this.stackClosed);
    },

    unregisterSearchModel: function (model) {
      this.stopListening(model);
    },

    handleWindowScrolling: function () {
      if (this.userHasScrolled) return;

      if (this.scrollTimer_window !== null) clearTimeout(this.scrollTimer_window);
      this.scrollTimer_window = setTimeout(_.bind(function () {
        this.userHasScrolled = true;
      }, this), 100);
    },

    afterChangeView: function (name, constraint) {
      if (!name) return;

      var extendedTab = constraint && constraint.and && constraint.and[1] && constraint.and[1].name;

      // Do not set the tab if not available
      // this.queryContext.app_tab_id = "";
      // this.queryContext.app_extend_tab_id = "";

      if (name) this.queryContext.app_tab_id = name;
      if (extendedTab) this.queryContext.app_extend_tab_id = extendedTab;
    },

    beforeactionPerformed: function (actionName) {
      this.setLastTriggeredActionName(actionName);
    },

    getValueFromProperty: function (options, property) {
      return  options.model.get(property, { format: "VALUE", overridePropertyFormat: true }) || '';
    },

    actionPerformed: function (actionName, options) {
      var that = this;
      var href,
        comment,
        weight = 0,
        customActionOptions;
    
      var actionType = this.getActionTypeFromAction(options);
      if (actionType) actionName = actionType;

      if (actionName == "preview") {
        weight = this.WEIGHT_PREVIEW;
        this.handleOpenPreview(options);

      } else if (actionName == "openHref") {
        weight = this.WEIGHT_OPENHREF;
        var openHrefOptions = options.actionargs && options.actionargs[0];
        href = openHrefOptions && openHrefOptions.href;
        this.handleOpenFolder();

      } else if (actionName.includes("client_notification")) {
        weight = options.weight;
        comment = options.comment;
      } else if (actionName == "vote") {
        if (vote_action == "toggleCommentBox") {
          return;
        }
        var vote_options = options.actionargs && options.actionargs[0];
        var actionElement = options && options.actionargs[2];
        
        if (actionElement && vote_options) {
          var actionValue = $(actionElement).val();
          var triggerValues = vote_options.triggerValues;
          if (triggerValues && actionValue) {
            vote_options.weight = triggerValues[actionValue];
          } else if (triggerValues && triggerValues.weight) {
            vote_options.weight = triggerValues.weight;
          }
        }

        var vote_weight = vote_options.weight;
        var vote_action = vote_options.action;

        if (vote_options.weight == "up") {
          weight = 1;
        } else if (vote_options.weight == "down") {
          weight = -1;
        }

        if (vote_options && vote_options.answer) {
          this.lastGivenAnswerIndex = vote_options.answer;
        } else {
          // is comment action
          options.actionargs[0].answer = this.lastGivenAnswerIndex;
        }

        comment = options.application.options.comment;
        options.application.options.comment = "";

      } else if (actionName == "sendFeedback") {
        options = _.extend(options, options.application.previewFeedback);
        comment = options.comment;
        weight = options.weight;

      } else if (this.TRIGGER_ACTION_NAMES.indexOf(actionName) !== -1) {
        var action = options && options.actionargs[1];
        if (actionName === 'customAction') {
          customActionOptions = options && options.actionargs[0];
          if (!_.isUndefined(customActionOptions)) {
            delete customActionOptions.actionType;
          }
        }
        actionName = action;
        weight = this.WEIGHT_CUSTOM_ACTIONS;

      } else {
        return;
      }

      var resultChannel = options.model.channel;
      var defaultChannels = this.application.models.defaultChannels;
      var stub = this.application.api.personalization.createStub();
      var responseObserver = _.extend({}, Backbone.Events);

      var resultContext = {
        "action": actionName,
        "weight": weight,
        "url": href,
        "action_trigger_event": this.getActionTriggerEvent(options.e)
      };

      if (customActionOptions) {
        resultContext["options_json"] = JSON.stringify(customActionOptions);
      }

      this.queryContext = this.getQueryContextProperties(_.extend(options, { actionPerformed: true }));
      resultContext = _.extend(resultContext, {
        "query_context": this.queryContext
      });

      if (resultChannel) {
        var resultID = options.model.get("location"),
            meskey = options.model.get("mes:key"),
            fqcategory = options.model.get("category") && options.model.get("categoryinstance") ? options.model.get("category") + ":" + options.model.get("categoryinstance") : null,
            position = options.model.position,
            pageNumber = options.model.get("page_number"),
            title = this.getValueFromProperty(options, 'title'),
            url = this.getValueFromProperty(options, 'url');
        
        resultContext = _.extend(resultContext, {
        "result_id": resultID,
        "position": position,
        "page_number": pageNumber,
        "fqcategory": fqcategory,
        "key": meskey,
        "title": title,
        "url": url,
        "comment": comment
        });
      }

      if (comment) {
        resultContext = _.extend(resultContext, {
          "comment": comment
        });
      }

      for ( var i in resultContext ) {
        if ( resultContext[i] === null || resultContext[i] === undefined ) {
          delete resultContext[i];
        }
      }

      var channels = resultChannel && [resultChannel] || defaultChannels;

      if (channels && this.personalizationIsEnabled) {
        var request = {};

        var isAnswer = options.model.isAnswer;
        if (isAnswer === true) {
          var text = options.model.get("text") || "";
          request.query_answer = _.extend(resultContext, {
            answer: {
              "text": text.text,
              "property_name": options.model.get("property_name"),
              "context_before": text.context_before,
              "context_after": text.context_after,
              "text_start_pos": text.text_start_pos,
              "text_end_pos": text.text_end_pos
            }, 
            similarity_score: options.model.get("score"),
            position: options.model.get("position")
          });

        } else {
          request.query_result = resultContext;
        }

        var promise = stub.cast(
          channels, 
          request,
          responseObserver
        );
        promise.always(function (val) {
          that.application.trigger("queryprofilerdone");
        });
      }
    },

    getActionTriggerEvent: function (event) {
      var action;
      switch (event && event.which) {
        case 1: 
          action = "MOUSE_LEFT_BUTTON";
          break;
        case 2:
          action = "MOUSE_MIDDLE_BUTTON";
          break;
        case 3:
          action = "MOUSE_RIGHT_BUTTON";
          break;
        case 13: 
          action = "KEYBOARD_ENTER";
          break;
        case 32: 
          action = "KEYBOARD_SPACE";
          break;
        default:
          action = "UNKNOWN_EVENT";
      }
      return action;
    },

    getActionTypeFromAction: function (options) {
      return options && options.args && options.args["actionType"];
    },

    getQueryContextProperties: function (options) {
      
      var personalization = _.find(this.application.models.sourceInfo.get("sources.sources[0].services"), function(obj) { return obj.id == "personalization" });
      var properties = personalization && personalization.personalization_options && personalization.personalization_options.properties;
      if (properties && properties.length) {
        var that = this;
        this.queryContext.properties = [];
        _.each(properties, function (prop) {
          
          if ( prop.source == "result" && (!options || !options.actionPerformed) ) return;
        
          that.queryContext.properties.push({
            key: prop.key,
            value: that.getValueFromPersonalizationProperties(_.extend(prop, options))
          })
        });
      }

      if (_.isFunction(this.personalizationQueryContextProperties)) {
        this.queryContext.properties =  _.union(this.queryContext.properties, this.personalizationQueryContextProperties());
      }

      return this.queryContext;
    },

    getValueFromPersonalizationProperties: function (options) {
      if (options.source == "profile") {
        var profileAvailable = this.application.models.profileSettings && (this.application.models.profileSettings.length > 0);
        if (profileAvailable) {
          var profile = this.application.models.profileSettings.models[0].get("data").settings;
          } else { 
            var profile = false; 
          }
          if (profile && profile[options.field]) { return profile[options.field] + "" }

        } else if (options.source == "searchrequest") {
          var searchRequestValue = this.application.models && this.application.models.search &&  this.application.models.search.input.get(options.field);
          if (searchRequestValue) return searchRequestValue + "";

        } else if (options.source == "application") {
        return this.getPersonalizationApplication(options);

      } else if (options.source == "result") {
        var value = options.model && options.model.get(options.field, { format: "VALUE", overridePropertyFormat: true });
        if (value) {
          if (_.isArray(value)) return value.join(",");
          return value;
        }
      }
    },

    getPersonalizationApplication: function (options) {
      //prototype it
    },

    handleOpenPreview: function (options) {
      this.sessionContext.actions.preview = {
        "start": this.getTime()
      };

      $(document).on("scroll", _.bind(this.handlePreviewScrollEvent, this, options));
    },

    handlePreviewScrollEvent: function (options) {
      if (arguments[1].type == "scroll") {
        if (this.scrollTimer_preview !== null) clearTimeout(this.scrollTimer_preview);
        this.scrollTimer_preview = setTimeout(_.bind(function () {

          var h = document.documentElement,
            b = document.body,
            st = 'scrollTop',
            sh = 'scrollHeight';

          var percent = parseInt((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100);
          var queryProfilerActions = this.application.queryProfiler.sessionContext.actions.preview;

          if ((!queryProfilerActions || !queryProfilerActions.scrollPosition) || (queryProfilerActions.scrollPosition < percent)) {
            this.application.queryProfiler.sessionContext.actions.preview.scrollPosition = percent;
          }

        }, options), 250);
      }
    },

    handleOpenFolder: function () {
      this.sessionContext.actions.openHref = {
        "start": this.getTime()
      }
    },

    stackClosed: function (stackModel) {
      //preview stopListening
      $(document).off("scroll");

      if (stackModel && stackModel.get && this.sessionContext && this.sessionContext.actions && this.sessionContext.actions.preview && (this.sessionContext.actions.preview.start && !this.sessionContext.actions.preview.end)) {
        this.sessionContext.actions.preview.end = this.getTime();
        this.setPersonalization(stackModel.get("actionOptions"));
      };
    },

    setPersonalization: function (options) {
      if (!this.sessionContext.actions.preview.end || !this.sessionContext.actions.preview.start) return;

      var resultChannel = options.model && options.model.channel;

      if (resultChannel && this.personalizationIsEnabled) {

        var stub = this.application.api.personalization.createStub(),
          responseObserver = _.extend({}, Backbone.Events),
          resultID = options.model.get("location"),
          meskey = options.model.get("mes:key"),
          fqcategory = options.model.get("category") + ":" + options.model.get("categoryinstance"),
          pageNumber = options.model.get("page_number"),
          url = this.getValueFromProperty(options, 'url'),
          title = this.getValueFromProperty(options, 'title'),
          scrollPosition = this.sessionContext.actions.preview.scrollPosition || 0,
          position = options.model.position,
          actionTriggerEvent = this.getActionTriggerEvent(options.event);
          
          var duration_in_ms = this.sessionContext.actions.preview.end - this.sessionContext.actions.preview.start;

          var promise = stub.call(resultChannel,
                                  {
                                    "query_result":  {
                                      "query_context": this.application.queryProfiler.queryContext,
                                      "position": position,
                                      "url": url,
                                      "title": title,
                                      "result_id": resultID,
                                      "action": "previewClosed",
                                      "action_trigger_event": actionTriggerEvent,
                                      "duration_in_ms": duration_in_ms,
                                      "scroll_position_in_percentage": scrollPosition,
                                      "fqcategory": fqcategory,
                                      "page_number": pageNumber,
                                      "key": meskey
                                    }
                                  },
                                  responseObserver
                                 );
          promise.always(function() {
          });
        }

    },

    handleFocusEvent: function (e) {
      if (this.sessionContext && this.sessionContext.actions && this.sessionContext.actions.openHref && (this.sessionContext.actions.openHref.start && !this.sessionContext.actions.openHref.end)) {
        this.sessionContext.actions.openHref.end = this.getTime();
        var diff = (this.sessionContext.actions.openHref.end - this.sessionContext.actions.openHref.start) / 1000;
      }
    },

    setQueryID: function (queryID) {
      this.queryContext.prev_query_id = this.queryContext.query_id || null;
      this.queryContext.prev_refinement_id = this.queryContext.refinement_id || null;
      this.queryContext.query_id = queryID;

      if (!this.queryContext.prev_refinement_id) delete this.queryContext.prev_refinement_id;
      delete this.queryContext.refinement_id;
    },

    setRefinementID: function (refinementID) {
      this.queryContext.prev_refinement_id = this.queryContext.refinement_id;
      this.queryContext.refinement_id = refinementID;
    },

    createRequestTransformer: function () {
      var that = this;
      return function (channel, request, options) {
        if (request.path == "search" && channel && channel.id && that.personalizationIsEnabled) {
          request.query_context = that.queryContext;
          request.query_context_user_query = that.application.getUnparsedUserQuery();
        }
        return request;
      }
    },

    destroy: function () {
      this.stopListening();
    },

    onUserQuery: function (model, options) {
      this.queryContext = this.getQueryContextProperties();

      var userQueryObject = model.get("user.query.and.query");

      var currentQueryObject = this.currentQueryObject;
      if (!_.isEqual(currentQueryObject, userQueryObject)) {

        this.setQueryID(this.getTime());
        this.checkForNewSession();

        this.currentQueryObject = userQueryObject;
        this.setQueryTriggerType(this.QUERY_TRIGGER_TYPES.USER_QUERY, options);
      } else {
        this.onQueryRefinement(model);
        this.setQueryTriggerType(this.QUERY_TRIGGER_TYPES.REFINEMENT, options);
      }

      this.setCustomQueryContextProperties(options);
      this.setApplicationId();
      this.setQueryTriggerAction(options);
    },

    checkForNewSession: function () {
      var prevQueryID = this.queryContext.prev_query_id,
        queryID = this.queryContext.query_id;

      if (!prevQueryID) return false;

      var queryDiff = ((queryID - prevQueryID) / 1000);

      if (queryDiff > this.SEARCH_INTERVALL) {
        this.sessionContext = this.setNewSession();
      }
    },

    setCustomQueryContextProperties: function (options) {
      if (_.isFunction(this.personalizationQueryContextProperties)) {
        this.queryContext.properties = this.personalizationQueryContextProperties();
      }
    },

    setApplicationId: function () {
      this.queryContext.application_id = this.application.options.applicationId;
    },

    setQueryTriggerType: function (type, options) {
      var triggerActionName = options && options.triggerActionName;
      if (triggerActionName && this.AUTOMATIC_TRIGGER_ACTION_TYPES.indexOf(triggerActionName) !== -1) {
        this.queryContext.query_trigger_type = this.QUERY_TRIGGER_TYPES.AUTOMATIC;
      } else {
        this.queryContext.query_trigger_type = type;
      }
    },

    setQueryTriggerAction: function (options) {
      var triggerActionName = options && options.triggerActionName;

      if (triggerActionName) {
        this.setLastTriggeredActionName(triggerActionName);
      }

      this.queryContext.query_trigger_action = this.getLastTriggeredActionName();
      this.setLastTriggeredActionName(null);
    },

    getLastTriggeredActionName: function () {
      if (!this.initialQueryTriggerActionURLParameterHandled && !this.application.parentApplication) {
        this.initialQueryTriggerActionURLParameterHandled = true;
        var initialQueryTriggerActionURLParameter = Browser.getURLParameter("initialQueryTriggerAction");
        if (initialQueryTriggerActionURLParameter) {
          return initialQueryTriggerActionURLParameter;
        }
      }
      return this.application.options.lastTriggeredActionName;
    },

    setLastTriggeredActionName: function (actionName) {
      this.application.options.lastTriggeredActionName = actionName;
    },

    setNewSession: function () {
      var prev_session_id = this.sessionContext && this.sessionContext.session_id;

      var session = {};
      session.actions = {};
      session.session_id = this.getTime();
      if (prev_session_id) session.prev_session_id = this.sessionContext.session_id;

      return session;
    },

    onQueryRefinement: function (model) {
      var constraintsObject = model.get("user.constraints");

      this.currentRefinements = constraintsObject;

      this.queryContext.prev_refinement_id = this.queryContext.refinement_id;
      this.queryContext.refinement_id = this.getTime();

      if (!this.queryContext.currentRefinements) delete this.queryContext.currentRefinements;
      if (!this.queryContext.prev_refinement_id) delete this.queryContext.prev_refinement_id;
    },

    getTime: function () {
      return new Date().getTime().toString();
    }

  });

  return QueryProfiler;
 });
